import { TemplateMessages } from 'constants/messages/template'
import { Box, CircularProgress, Typography } from '@mui/material'
import React, { FC } from 'react'
import { useAppSelector } from 'store/hooks'

interface LoadingProps {
  message?: string
}

const Loading: FC<LoadingProps> = ({ message }) => {
  const { loadingMessage } = useAppSelector(state => state.app)

  return (
    <Box alignItems="center" display="flex" gap={2}>
      <CircularProgress color="secondary" size={24} />
      <Typography variant="body2">
        {message ? (
          `${message}, please wait...`
        ) : (
          <>
            {loadingMessage || TemplateMessages.defaultLoading}, please wait...
          </>
        )}
      </Typography>
    </Box>
  )
}

export default Loading
